namespace $ {

	export type $shm_agent_history_item = {
		id: string
		turn_id: string
		role: 'user' | 'assistant'
		text: string
		created_at: number
	}

	export type $shm_agent_history_catalog = {
		items: readonly $shm_agent_history_item[]
		next: string | null
	}

	export type $shm_agent_history_turn = {
		turn_id: string
		user: $shm_agent_history_item | null
		agents: readonly $shm_agent_history_item[]
	}

}

namespace $.$$ {

	export class $shm_agent_history extends $.$shm_agent_history {

		history_pages() {
			return [ this.Catalog(), this.Detail() ]
		}

		catalog_rows() {
			const rows = this.catalog_items().map( ( item: $shm_agent_history_item )=> this.Catalog_link( item.turn_id ) ) as $mol_view[]
			if( this.has_more() ) rows.push( this.Catalog_more() )
			return rows.length ? rows : [ this.Catalog_empty() ]
		}

		catalog_item( turn: string ) {
			return this.catalog_items().find( ( item: $shm_agent_history_item )=> item.turn_id === turn ) as $shm_agent_history_item | undefined
		}

		catalog_arg( turn: string ) {
			return { agent_history_turn: turn }
		}

		catalog_current( turn: string ) {
			return this.selected() === turn
		}

		@ $mol_action
		catalog_select( turn: string, next?: Event ) {
			if( next === undefined ) return null
			const event = next as MouseEvent
			if( event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ) return next
			event.preventDefault()
			this.selected( turn )
			return next
		}

		catalog_text( turn: string ) {
			return this.catalog_item( turn )?.text || 'Без текста'
		}

		catalog_time( turn: string ) {
			return this.time_text( this.catalog_item( turn )?.created_at )
		}

		detail_data() {
			return this.detail() as $shm_agent_history_turn | null
		}

		detail_title() {
			const stamp = this.detail_data()?.user?.created_at
			return stamp ? `Сообщение · ${ this.time_text( stamp ) }` : 'Сообщение'
		}

		detail_sections() {
			const detail = this.detail_data()
			if( !detail?.user ) return [ this.No_answers() ]
			return [ this.User_panel(), this.Previous_panel(), this.Last_panel() ]
		}

		user_text() {
			return this.detail_data()?.user?.text || 'Без текста'
		}

		user_time() {
			return this.time_text( this.detail_data()?.user?.created_at )
		}

		previous_items() {
			return this.detail_data()?.agents.slice( 0, -1 ) || []
		}

		previous_rows() {
			const rows = this.previous_items().map( item => this.Previous_message( item.id ) ) as $mol_view[]
			return rows.length ? rows : [ this.No_previous() ]
		}

		previous_item( id: string ) {
			return this.previous_items().find( item => item.id === id )
		}

		previous_text( id: string ) {
			return this.previous_item( id )?.text || 'Без текста'
		}

		previous_time( id: string ) {
			return this.time_text( this.previous_item( id )?.created_at )
		}

		last_item() {
			return this.detail_data()?.agents.at( -1 )
		}

		last_text() {
			return this.last_item()?.text || 'Без текста'
		}

		last_time() {
			return this.time_text( this.last_item()?.created_at )
		}

		last_rows() {
			return this.last_item() ? [ this.Last_message() ] : [ this.No_answers() ]
		}

		time_text( stamp?: number ) {
			if( !stamp ) return ''
			return new Date( stamp * 1000 ).toLocaleString( 'ru-RU', {
				day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
			} )
		}

	}

}
